export type StorageConnectionType = 'files' | 'kevin';